import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import BackButton from "../../../components/button/BackButton";
import columns from "../../../columns/files/bookKeepingFile";
import toast from "react-hot-toast";
import {
  GetBookKeepingApi,
  UpdateBookKeepingStatusApi,
} from "../../../api/request/service";
import ViewBookKeepingModal from "../../files/components/ViewBookKeepingModal";
import View from "../../../assets/View";
import moment from "moment";
import SkeletonTable from "../../../components/table/SkeletonTable";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";

const ViewBookKeepingDetails = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isBookOpen, setIsBookOpen] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [selectedViewData, setSelectedViewData] = useState(null);

  const getBookKeeping = async () => {
    try {
      setIsLoading(true);
      const params = { file_id: id };
      const { data } = await GetBookKeepingApi(params);
      const statusMap = {};
      data?.data?.forEach((item) => {
        statusMap[item.id] = item.status;
      });
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            submittedDate: item?.submitted_date
              ? moment(item?.submitted_date).format("lll")
              : "--",
            completedDate: item?.completed_date
              ? moment(item?.completed_date).format("lll")
              : "--",
            action: (
              <button
                onClick={() => {
                  setIsBookOpen(true);
                  setSelectedViewData(item);
                }}
              >
                <View />
              </button>
            ),
            status: (
              <p
                className={`${
                  item?.status === "completed"
                    ? "font-bold uppercase text-green-500"
                    : "font-bold uppercase text-orange-500"
                }`}
              >
                {item?.status}
              </p>
            ),
          };
        })
      );

      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const handleCancelStatusChange = () => {
    setIsStatus(false);
    setSelectedRow(null);
  };

  const handleConfirmStatusChange = async () => {
    try {
      setIsStatusLoading(true);
      const { data } = await UpdateBookKeepingStatusApi({
        id: selectedRow?.id,
      });
      if (data?.status) {
        getBookKeeping();
        toast.success(data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
    } finally {
      setIsStatusLoading(false);
    }
    setIsStatus(false);
    setSelectedRow(null);
  };

  useEffect(() => {
    getBookKeeping();
  }, [id]);
  return (
    <>
      <div className="bg-white rounded-lg border border-1 mb-5">
        <div className="grid grid-cols-2 gap-3 p-4">
          <div className="space-y-1">
            <div>
              <p>
                <span className="font-semibold">Client Name : </span>{" "}
                {state?.client?.user?.name}
              </p>
            </div>
            <div>
              <p>
                <span className="font-semibold">Client Email : </span>{" "}
                {state?.client?.user?.email}
              </p>
            </div>
          </div>

          <div className="space-y-1">
            <div>
              <p className="capitalize">
                <span className="font-semibold">File Name :</span>{" "}
                {state?.client?.service_name_slug}
              </p>
            </div>
            <div>
              <p>
                <span className="font-semibold">File No.:</span>{" "}
                {state?.client?.file_number}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-1 mb-5 p-5">
        <div className="flex items-center gap-3 mb-5">
          <BackButton />
          <div className="flex items-center gap-3 justify-between w-full">
            <h2 className="title">{state?.task?.name || "Review File"}</h2>
          </div>
        </div>
        <SkeletonTable columns={columns} data={data} isLoading={isLoading} />
      </div>

      <ViewBookKeepingModal
        data={data}
        isLoading={isLoading}
        isOpen={isBookOpen}
        setIsOpen={setIsBookOpen}
        selectedData={selectedViewData}
        userId={state?.client?.user_id}
      />

      <ConfirmationModal
        isOpen={isStatus}
        setIsOpen={setIsStatus}
        isLoading={isStatusLoading}
        loadingLabel={"Changing status..."}
        type="success"
        message="Are you sure you want to complete this bookkeeping file?"
        onConfirm={handleConfirmStatusChange}
        onCancel={handleCancelStatusChange}
      />
    </>
  );
};

export default ViewBookKeepingDetails;
